import React, { useEffect } from 'react';
import useResizeObserver from 'use-resize-observer';
import { useFileOverlayContext } from '../../FileOverlay/FileOverlayContext/FileOverlayContext';
import {
    FilePaneBlankSlate,
    FilePaneDeletedSlate,
    FilePaneWrapper,
} from '../../FileOverlay/FilePane';
import Artboard from '../../FileOverlay/FilePane/Artboard';
import Image from '../../FileOverlay/FilePane/Image';
import ScrollPane from '../../FileOverlay/FilePane/ScrollPane';
import calculatePosition from '../../FileOverlay/FilePane/calculatePosition';
import { calculateScale } from '../../FileOverlay/FilePane/calculateScale';
import { KissFile } from '../types';

interface KissFilePaneProps {
    file: KissFile;
}

function KissFilePane({ file }: KissFilePaneProps) {
    if (file.isDeleted && !file.previewUrl) {
        return <FilePaneDeletedSlate />;
    }
    if (!file.width || !file.previewUrl) {
        return <FilePaneBlankSlate />;
    }

    // eslint-disable-next-line react-hooks/rules-of-hooks
    const { viewSize, setViewSize, zoomLevel } = useFileOverlayContext();
    // eslint-disable-next-line react-hooks/rules-of-hooks
    const [ref, width, height] = useResizeObserver();

    // FIXME: Rule of hooks violation https://gitlab.com/vistaprint-org/99designs/frontend/-/issues/3523
    // eslint-disable-next-line react-hooks/rules-of-hooks
    useEffect(() => {
        setViewSize({ width, height });
    }, [width, height, setViewSize]);

    const imageSize = {
        width: file.width,
        height: file.height,
    };

    const scale = calculateScale(imageSize, viewSize, zoomLevel);
    const { artboardSize, artboardOrigin, scaledImageSize } = calculatePosition(
        imageSize,
        viewSize,
        scale
    );

    return (
        <FilePaneWrapper ref={ref as React.RefObject<HTMLDivElement>}>
            <ScrollPane viewSize={viewSize} scaledImageSize={scaledImageSize}>
                <Artboard artboardSize={artboardSize}>
                    <Image
                        previewUrl={file.previewUrl}
                        imageSize={imageSize}
                        artboardOrigin={artboardOrigin}
                        scale={scale}
                        artboardSize={artboardSize}
                    />
                </Artboard>
            </ScrollPane>
        </FilePaneWrapper>
    );
}

export default KissFilePane;
